const data = {
  'home.beauty_advisor': 'ビューティアドバイザー',
  'home.virtual_mirror': 'バーチャルミラー',
  'home.logout': 'ログアウト',
  'without_quiz.access_cam': 'カメラへのアクセスを 許可する',
  'without_image.option_yes': 'はい',
  'without_image.option_no': 'いいえ',
  'dba.find_look': 'あなたに合ったるルックを探します',
  'dba.about_urself': 'あなたについて教えてください',
  'dba.next': '次へ進む',
  'dba.type': 'あなたのタイプは',
  'dba.submit': '選択したカラー（デザイン）を試してみる',
  'quiz.skin_color': 'あなたの肌のトーンは？',
  'quiz.hair_Color': 'あなたの髪の色は?',
  'menu.home': 'ホーム',
  'menu.share': 'Share',
  'menu.save': '保存',
  'menu.trail': '試す',
  'menu.find': '眼科医を探す',
  'menu.product': '製品情報',
  'lens.bright': 'ラディアント ブライト™',
  'lens.shine': 'ナチュラル シャイン®',
  'lens.charm': 'ラディアント チャーム™',
  'lens.chic': 'ラディアント シック™',
  'lens.sweet': 'ラディアント スウィート™',
  'lens.vivid': 'ヴィヴィッド スタイル',
  'lens.accent': 'アクセント スタイル',
  'footer.care': 'レンズのお手入れについて',
  'footer.products': '製品について',
  'footer.legal': '利用規約について',
  'footer.acuvue': 'アキュビュー®ディファイン®について',
  'footer.contact': '問い合わせ',
  'footer.privacy': '個人情報の取り扱いについて',
  'footer.label': '詳しく',
  'footer.makeup': 'メイクレクチャー',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Submit',
  'nav.welcome_guest': 'ゲスト',
  'vm.currently_wearing': '装用中',
  'vm.rec_variant': 'おすすめのレンズ',
  'product_info.about': 'レンズについて',
  'lens.now': 'Now',
  'tabs.fresh_lenses': 'ディファイン<br/>フレッシュシリーズ',
  'tabs.classic_lenses': 'ディファイン',
  'tabs.makeup': 'メイクアップ',
  'tabs.looks': 'Looks',
  'tabs.insertion': '装用',
  'tabs.removal': 'はずし方',
  'tooltip.home': 'ホーム',
  'tooltip.ba': 'パーソナルカラー診断',
  'tooltip.care': 'レンズケア',
  'tooltip.more': 'More Options',
  'tooltip.buy': '購入',
  'tooltip.share': '共有',
  'tooltip.trial': '試す',
  'tooltip.ecp': '取扱い店を探す',
  'tooltip.logout': 'ログアウト',
  'tooltip.vm': 'バーチャルで装用する',
  'modal.share': 'Share',
  'modal.buy': '購入',
  'modal.free_trial': '試す',
  'modal.shop_now': 'Shop Now',
  'modal.go': 'Go',
  'looks.downloadPdf': 'Download Tutorial',
  // "home.lens_find": "私に合うレンズを見つける",
  // "home.lens_continue": "続ける",
  // "home.lens_find": "私に合うレンズを見つける",
  // "home.lens_continue": "続ける",
  'home.quiz_find': '私に合うキャラクターを見つける',
  'without_quiz.access_cam_sub_text': 'ライブ装用に使用',
  'without_image.Allow': '許可しない',
  'without_image.OK': '許可する',
  'looks.you_have_selected': 'あなたが選んだ: ',
  'looks.you_have_chosen': '選択中のカラー（デザイン）',
  'guides.how_to_put_on_lens': 'レンズを装用するための4ステップ',
  'guides.how_to_remove_lens': 'レンズをはずすための3ステップ',
  'tutorials.or': 'OR',
  'tutorials.scan': 'Scan QR code to download',
  'tutorials.product_unavailable':
    'This product is currently unavailable in this market.',
  'tutorials.look': 'Look ',
  'products.disclaimer_header': '参考/免責事項',
  'tutorials.purchase': 'Buy online',
  'tutorials.lens': 'Lens',
  'looks.best_suited': 'look is best suited with',
  'looks.product_unavailable': 'Not Available',
  'looks.with_lens': 'With Lens:',
  'looks.with_looks': 'With Looks:',
  'permissions.allow_look_removal': 'This action would remove applied look',
  'permissions.allow_makeup_removal': 'This action would remove applied makeup',
  'permissions.allow_look_removal_sub_text': 'Do you want to proceed?',
  'recommended.design': 'Recommended design for you',
  'tabs.pls_select_look': 'Please select a look',
  'tabs.pls_select_lens': 'レンズを選択してください。',
  'tabs.pls_select_makeup_category': 'メイクアイテムを選択してください。',
  'without_quiz.access_cam1': 'カメラのアクセスを',
  'without_quiz.access_cam2': '許可する',
  'quiz.help': 'すべての質問に回答の上、「次へ進む」ボタンを押してください。',
  'recommended.option':
    'あなたのなりたいイメージを以下の{count}つから選んでください。',
  'sticker.filterText': 'フィルター',
  'sticker.ON/OFF': 'ON / OFF',
  'cookie_policy.cookie_policy_footer': 'Cookieポリシー',
  'cookie_policy.cookie_policy_vm': 'デフォルト設定では、必須Cookieを除き（但し、個人情報は収集しません）、Cookieは無効化されており、設定を変更したい場合は、「<span id="ot-sdk-btn" class="ot-sdk-show-settings nolink">Cookie Settings</span>」から変更してください。',
};

export default data;
